module.exports = __webpack_public_path__ + "static/virus-prototype-8677508d3cf9498dab86d9f3077305ae.webm";